export class Geopoint {
    latitude : number;
    longitude : number;
}



// WEBPACK FOOTER //
// ./src/app/models/geopoint.ts